module.exports = __webpack_public_path__ + "static/media/control_de_carga1.686579c3.svg";